import type { SubpublisherDestinationUrlEntry } from '../elements/SubpublisherDestinationSection'

type PublisherDestinations = Pick<
  SubpublisherApprovalStatus,
  'publisher_id' | 'publisher_name' | 'destination_urls'
>

export const projectSubpublisherDestinations = (
  publisher: PublisherDestinations,
  destinationsConfig: DestinationUrlsConfig[] = []
): SubpublisherDestinationUrlEntry[] => {
  const configuredDestinations = destinationsConfig.filter(
    destination =>
      destination.publisher_id === publisher.publisher_id && destination.code
  )
  const savedDestinations = publisher.destination_urls || []

  if (!configuredDestinations.length && !savedDestinations.length) {
    return [{ url: '', name: publisher.publisher_name }]
  }

  const projectedDestinations = configuredDestinations.map(destination => {
    const savedDestination = savedDestinations.find(
      saved => saved.brand === destination.code
    )

    return {
      brand: destination.code,
      name: destination.name || destination.code,
      url: savedDestination?.url || ''
    }
  })

  const configuredBrands = new Set(
    configuredDestinations.map(destination => destination.code)
  )
  const unconfiguredSavedDestinations = savedDestinations
    .filter(saved => !saved.brand || !configuredBrands.has(saved.brand))
    .map(saved => ({
      ...saved,
      name: saved.brand || publisher.publisher_name
    }))

  return [...projectedDestinations, ...unconfiguredSavedDestinations]
}
